<template>
  <div class="app-root">
    <!-- Ant Design Vue ConfigProvider -->
    <a-config-provider :locale="zhCN">
      <!-- Element Plus ConfigProvider（兼容未迁移页面） -->
      <el-config-provider :locale="locale">
        <div class="main-content">
          <router-view />
        </div>
      </el-config-provider>
    </a-config-provider>
  </div>
</template>

<style lang="scss">
* {
  padding: 0;
  margin: 0;
  box-sizing: border-box;
}

html, body, #app {
  height: 100%;
  width: 100%;
}

.app-root {
  height: 100%;
  width: 100%;
}

.main-content {
  flex: 1;
  height: 100vh;
  padding-left: 0 !important;
  overflow: auto;
}

.warning-row {
  --el-table-tr-bg-color: var(--el-color-warning-light-9);
}

.success-row {
  --el-table-tr-bg-color: var(--el-color-success-light-9);
}

.iconfont {
  font-size: 1.25rem !important;
}

::-webkit-scrollbar {
  width: 12px;
  height: 12px;
}

::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 5px;
}

::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 5px;
  border: 3px solid transparent;
  background-clip: content-box;
}

::-webkit-scrollbar-thumb:hover {
  background: #555;
}
</style>

<script>
import { ElConfigProvider } from 'element-plus'
import zhCn from 'element-plus/dist/locale/zh-cn.mjs'
import zhCN from 'ant-design-vue/es/locale/zh_CN'
export default {
  data() {
    return {
      locale: zhCn,
      zhCN: zhCN,
    }
  },
  components: {
    ElConfigProvider,
  },
}
</script>
